/* =================== PAGAMENTO =================== */

/* etapas/processo de doacao e pagamento */
if(param1 == 'doacao'){

  // FORMULARIO EM ETAPA
  $(function () {

    var $sections = $(".form-section");

    var url_geral = $("#infos").data("url-base");

    // Exibe/Oculta os campos da forma de pagamento escolhida
    $('input[name="forma-pagamento"]').on("change", function() {
      $(".forma-pag-content").slideUp();
      $(".forma-pag-content .campo").prop("disabled", true);
      $(".forma-pag-content .campo").prop("required", false);

      $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
      $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
        "disabled",
        false
      );
      $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
        "required",
        true
      );
    });

    function parcelamento(total, parcelas) {
      const infosParcelamento = {
        total: total,
        parcelas: parcelas
      };
      $.ajax({
        type: "POST",
        url: url_geral + "acoes/app/pagarme/parcelamento.php",
        data: infosParcelamento,
        async: false,
        cache: false,
        success: function (response) {
          const campoParcela = $('#parcelas');
          let installments = $.parseJSON(response);
          console.log(installments);
          if (installments.length > 0) {
            $("#parcelas").html("");
            $("#parcelas").append('<option value="" hidden>Parcelas</option>');
            for (let item in installments) {
              let parcelaVerify = installments[item].installment;
              parcelaVerify = parseInt(parcelaVerify);
              if (parcelaVerify <= parcelas) {
                let interestFree = installments[item].interestFree;
                if (typeof installments[item].interestFree === 'string' && installments[item].interestFree === 'false') {
                  interestFree = false;
                }
                const installmentFree = interestFree ? ' (sem juros)' : ' (R$ '+formatMoneyBR(installments[item].amount)+')';
                campoParcela.append(
                  `<option value="${installments[item].installment}x${installments[item].installment_amount}">${
                    installments[item].installment
                  }x de R$ ${formatMoneyBR(installments[item].installment_amount)}${installmentFree} </option>`,
                );
              }
            }
          }
        },
      });
    }

    let parcelas = $('#parcelas_limite').val();
    let total_compra;
    if($('#tipo_venda').val() == 'assinatura'){
      total_compra = formatMoneyBD($('input[name=doacao]:checked').data('valor'));
    }else if($('#tipo_venda').val() == 'unico'){
      total_compra = formatMoneyBD($('#valor-custom').val());
    }else if($('#tipo_venda').val() == 'unico-predefinido'){
      total_compra = formatMoneyBD($('input[name=doacao]:checked').data('valor'));
    }
    parcelamento(total_compra, parcelas);

    $('.vale-input').on('change', function(e){
      $('#campanha_plano_id').val('');
      $('#tipo_venda').val($(this).data('forma'));
      $('#campanha_plano_id').val($(this).data('plano'));
      if($('#tipo_venda').val() == 'assinatura'){
        total_compra = formatMoneyBD($('input[name=doacao]:checked').data('valor'));
        parcelamento(total_compra, parcelas);
        $('#valor-custom').prop("required", false);
        $(".forma-pag-content").slideUp();
        $('input[name="forma-pagamento"]').val();
        $('input[name="forma-pagamento"]').prop('checked', false);
        $('#cartao').click();
        $('.cartao-caixa').show();
        $('#parcelas').val('');
        $('#parcelas').prop("required", false);
        $('.parcelas-caixa').hide();
        $('.boleto-caixa').hide();
        $('.pix-caixa').hide();
        console.log(total_compra);
        console.log(formatMoneyBR(total_compra));
        $('.tipo-pagamento').html('Pagamento Recorrente: R$ '+formatMoneyBR(total_compra));
        $('.tipo-pagamento-subtitulo').html('Todo mês o valor será cobrado do seu cartão de crédito');
      }else if($('#tipo_venda').val() == 'unico'){
        total_compra = formatMoneyBD($('#valor-custom').val());
        parcelamento(total_compra, parcelas);
        $('#valor-custom').prop("required", true);
        $(".forma-pag-content").slideUp();
        $('input[name="forma-pagamento"]').val();
        $('input[name="forma-pagamento"]').prop('checked', false);
        $('.cartao-caixa').show();
        $('#parcelas').val('');
        $('#parcelas').prop("required", true);
        $('.parcelas-caixa').show();
        $('.boleto-caixa').show();
        $('.pix-caixa').show();
        console.log(total_compra);
        console.log(formatMoneyBR(total_compra));
        $('.tipo-pagamento').html('Pagamento Único: R$ '+formatMoneyBR(total_compra));
        $('.tipo-pagamento-subtitulo').html('Cobrança realizada apenas uma vez');
      }else if($('#tipo_venda').val() == 'unico-predefinido'){
        total_compra = formatMoneyBD($('input[name=doacao]:checked').data('valor'));
        parcelamento(total_compra, parcelas);
        $('#valor-custom').prop("required", false);
        $(".forma-pag-content").slideUp();
        $('input[name="forma-pagamento"]').val();
        $('input[name="forma-pagamento"]').prop('checked', false);
        $('.cartao-caixa').show();
        $('#parcelas').val('');
        $('#parcelas').prop("required", true);
        $('.parcelas-caixa').show();
        $('.boleto-caixa').show();
        $('.pix-caixa').show();
        console.log(total_compra);
        console.log(formatMoneyBR(total_compra));
        $('.tipo-pagamento').html('Pagamento Único: R$ '+formatMoneyBR(total_compra));
        $('.tipo-pagamento-subtitulo').html('Cobrança realizada apenas uma vez');
      }
    });

    $('#valor-custom').bind('change', function(e){
      if($('#tipo_venda').val() == 'unico'){
        total_compra = formatMoneyBD($('#valor-custom').val());
        parcelamento(total_compra, parcelas);
        console.log(total_compra);
        console.log(formatMoneyBR(total_compra));
        $('.tipo-pagamento').html('Pagamento Único: R$ '+formatMoneyBR(total_compra));
      }
    });

    // Gera um hash com os dados sensíveis do cartão
    function hahsCartao() {
      const expiration_month = $('#validadeMes').val();
      const expiration_year = $('#validadeAno').val();
      const res_year = expiration_year.substr(2);
      const encription = $('#encription').val();
      const cardNumber = $('#numero_cartao').val();
      const cardName = $('#nome_cartao').val();
      const cardCvv = $('#cvv').val();
      if (cardNumber != '' && cardName != '' && cardCvv != '') {
        const card = {
          card_number: cardNumber,
          card_holder_name: cardName,
          expiration_month: expiration_month,
          res_year: res_year,
          card_expiration_date: expiration_month + res_year,
          card_cvv: cardCvv,
        };

        $.ajax({
          type: "POST",
          url: url_geral + "acoes/app/pagarme/pagarme.php",
          data: card,
          async: false,
          cache: false,
          success: function (response) {
            console.log(response);
            response = $.parseJSON(response);
            if(!response.cardtoken.id){
              $('#cartao_token').val('');
              $("#cartao_valido").val('false');
            }else{
              $('#cartao_token').val(response.cardtoken.id);
              $("#cartao_valido").val('true');
            }
          },
        });

      }
    }

    // Adiciona o campo com o hash
    function exibeHash(hash) {
      $('#cartao_token').val(hash);
    }
      
    setInterval(function(){ hahsCartao() }, 38000);

    // Chama a função que cria o hash
    $('.campos_cartao_token').on('change', function () {
      hahsCartao();
    });

    /* Navagacao etapas */
    function navigateTo(index) {
      // Mark the current section with the class 'current'
      $sections.removeClass("current").eq(index).addClass("current");
      // Show only the navigation buttons that make sense for the current section:
      $(".btn-container .previous").toggle(index > 0);
      var atTheEnd = index >= $sections.length - 1;
      $(".btn-container .next").toggle(!atTheEnd);
      $(".btn-container [type=submit]").toggle(atTheEnd);
      $(".next").html("Próximo &nbsp<i class='fas fa-arrow-right' style='margin-right: 0px;'></i>");
      $('.doacao-form-container').css('justify-content','unset');
      if (index == 1) {
        $('.doacao-form-container').css('justify-content','flex-start');
      }
      if (index == 2) {
        $(".next").html("Efetuar Pagamento &nbsp<i class='fas fa-arrow-right' style='margin-right: 0px;'></i>");
      }
      if (index == 3) {
        $(".btn-hide").hide();
        $(".previous").hide();
        $(".fim").show();
      }
    }

    function curIndex() {
      // Return the current index by looking at which section has the class 'current'
      return $sections.index($sections.filter(".current"));
    }

    // Previous button is easy, just go back
    $(".btn-container .previous").click(function () {
      navigateTo(curIndex() - 1);
    });

    // Next button goes forward iff current block validates
    $(".btn-container .next").click(function () {
      $("#form-doacao")
        .parsley()
        .whenValidate({
          group: "block-" + curIndex(),
        })
        .done(function () {
          // Pagamento
          if(curIndex() == 2){
            var freteChecked = $("input[name=forma-entrega]:checked").val();
            var pagamentoChecked = $("input[name=forma-pagamento]:checked").val();
            var dataEntregaChecked = $("#dta_entrega").val();
            /* if (!freteChecked) {
              showAlert("Atenção", "Escolha a forma de entrega.", "warning");
              return false;
            } */
            /* if (dataEntregaChecked == "") {
              showAlert("Atenção", "Escolha a data de entrega.", "warning");
              return false;
            } */
            if (!pagamentoChecked) {
              showAlert("Atenção", "Escolha a forma de pagamento.", "warning");
              return false;
            }
            let validado = true;
            if($("input[name=forma-pagamento]:checked").val() == 'cartao'){
              if($("#cartao_valido").val() == 'true'){
                validado = true;
              }else{
                validado = false;
              }
            }
            if (validado) {
              if ($("#form-doacao").parsley().validate()) {
                var url_geral = $("#infos").data("url-base");
                var dados = $("#form-doacao").serialize();
                $.ajax({
                  type: "POST",
                  url: url_geral + "acoes/app/pagamentos/grava_pagamento.php?acao=insert",
                  data: dados,
                  beforeSend: function () {
                    showLoading();
                  },
                  success: function (data) {
                    console.log(data);
                    data = $.parseJSON(data);
                    console.log(data);
                    if (data.status_pagamento != 14) {
                      // Proxima etapa
                      setTimeout(() => {
                        //navigateTo(curIndex() + 1);
                        window.location.href = $("#retorno_success").val() +
                        data.hash;
                      }, 3500);
                    } else {
                      hideLoading();
                      showAlert(
                        "Erro",
                        "Não foi possível realizar essa operação, revise os dados.",
                        "error"
                      );
                    }
                  },
                  error: function (xhr, type, exception, data) {
                    data = $.parseJSON(data);
                    hideLoading();
                    showAlert(
                      "Erro",
                      "Não foi possível realizar essa operação.",
                      "error"
                    );
                    console.log("ajax error response type " + type);
                  },
                });
              }
            } else {
              showAlert(
                "Erro",
                "Revise os dados do cartão de crédito.",
                "error"
              );
            }
          }else{
            navigateTo(curIndex() + 1);
          }
        });
    });

    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function (index, section) {
      $(section)
        .find(":input")
        .attr("data-parsley-group", "block-" + index);
    });
    navigateTo(0); // Start at the beginning

  });

  function flexOf() {
    $("#flexOff").addClass("centerOff");
  }

  function flexOn() {
    $("#flexOff").removeClass("centerOff");
  }

}
/* etapas e processo de doacao */
